import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("స్వాగతం");
      navigate("/admin");
    } catch (e) {
      const detail = e.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-[#FDFCF8] nv-noise flex items-center justify-center px-4">
      <div className="w-full max-w-md border border-[#E5E4DC] bg-white p-8 nv-selectable">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 bg-[#2E7D32] text-white flex items-center justify-center font-heading-te text-2xl">న</div>
          <div>
            <div className="font-heading-te text-2xl font-bold">Admin Login</div>
            <div className="font-body-te text-xs text-[#4A4A4A]">నల్లమల వాయిస్ CMS</div>
          </div>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form">
          <label className="block text-xs uppercase tracking-widest text-[#4A4A4A] mb-1">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full border border-[#E5E4DC] px-3 py-2 mb-4 focus:outline-none focus:border-[#2E7D32]"
            data-testid="admin-email-input"
          />
          <label className="block text-xs uppercase tracking-widest text-[#4A4A4A] mb-1">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full border border-[#E5E4DC] px-3 py-2 mb-6 focus:outline-none focus:border-[#2E7D32]"
            data-testid="admin-password-input"
          />
          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-[#2E7D32] hover:bg-[#1B5E20] text-white py-2.5 font-semibold disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {submitting ? "..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
